import { Box, Typography } from '@mui/material';
import React from 'react';
import { SingleChoiceAggregation as SingleChoiceAggregationType } from '../../redux/types';

type Props = {
  data: SingleChoiceAggregationType;
}

const SingleChoiceAggregation: React.FC<Props> = ({
  data,
}: Props) => (
  <Box>
    {
      Object.entries(data.payload).map(([key, val]) => (
        <Box key={key}>
          <Typography component="span">
            {`${val.text} `}
          </Typography>
          <Typography variant="body2" color="grey.500" component="span">
            {`×${val.count}`}
          </Typography>
        </Box>
      ))
    }
  </Box>
);

export default SingleChoiceAggregation;
